import { GlobalSearch } from '@pinnacleautomotive/clarity-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetOrdersQuery } from '../../redux/rtk/globalSearch.services';
import { selectUserCompaniesWithContracts } from '../../redux/selectors/userDataSelectors';

export default function AppGlobalSearch() {
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useState({ query: '', page: 1 });
  const companies = useSelector(selectUserCompaniesWithContracts);
  const groupedFilters = {
    AND: [],
  };
  groupedFilters.AND.push({
    OR: companies?.map(company => ({
      column: 'companyId',
      value: company.companyId,
      operator: 'eq',
    })),
  });
  const { data, isLoading, isFetching } = useGetOrdersQuery(
    {
      search: searchParams.query,
      groupedFilters,
      page: searchParams.page,
    },
    { skip: !searchParams.query }
  );

  return (
    <>
      <GlobalSearch
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        open={open}
        query={searchParams.query}
        setQuery={search => {
          setSearchParams({ query: search, page: 1 });
        }}
        color={theme => theme.palette.primary.contrastText}
        orders={data?.orders}
        loading={isLoading || isFetching}
        hasNextPage={data?.pagination.pageNumber < data?.pagination.totalPages}
        onLoadMore={() =>
          setSearchParams({
            query: searchParams.query,
            page: searchParams.page + 1,
          })
        }
      />
    </>
  );
}
